module.exports = __webpack_public_path__ + "img/kommune-544.28b4bb2c.svg";